import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import { setCarsResults, setSearchResults } from '../../redux/actions';


class CarsRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Cars Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getCars, payload);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(setCarsResults(this.response.data.records));
        if (this.response.data.metadata.search.length !== 0)
            this.dispatch(setSearchResults(this.response.data.metadata.search));
    }
}

export default CarsRequest;